import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./AdminNavBar.css";

const AdminNavBar = () => {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="adminNavbar">
      <div className="adminNavbarInner">
        <NavLink
          to="/admin/users"
          className={({ isActive }) =>
            `adminNavButton${isActive ? " adminNavButtonActive" : ""}`
          }
        >
          User Management
        </NavLink>
        <NavLink
          to="/admin/photos"
          className={({ isActive }) =>
            `adminNavButton${isActive ? " adminNavButtonActive" : ""}`
          }
        >
          Photo Management
        </NavLink>
      </div>
    </div>
  );
};

export default AdminNavBar;
